import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/esnext.global-this.js";
import { ExtensionType, settings, extensions } from '@pixi/core';
var detectAvif = {
  extension: {
    type: ExtensionType.DetectionParser,
    priority: 1
  },
  test: function () {
    var _test = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var avifData, blob;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (globalThis.createImageBitmap) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", false);
          case 2:
            avifData = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
            _context.next = 5;
            return settings.ADAPTER.fetch(avifData).then(function (r) {
              return r.blob();
            });
          case 5:
            blob = _context.sent;
            return _context.abrupt("return", createImageBitmap(blob).then(function () {
              return true;
            }, function () {
              return false;
            }));
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function test() {
      return _test.apply(this, arguments);
    }
    return test;
  }(),
  add: function () {
    var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formats) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", [].concat(_toConsumableArray(formats), ["avif"]));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function add(_x) {
      return _add.apply(this, arguments);
    }
    return add;
  }(),
  remove: function () {
    var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(formats) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", formats.filter(function (f) {
              return f !== "avif";
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function remove(_x2) {
      return _remove.apply(this, arguments);
    }
    return remove;
  }()
};
extensions.add(detectAvif);
export { detectAvif };